import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DataReject } from '../../beneficiaries-form/commons/interfaces/beneficiaries-form.interface';
import { FormControl, Validators } from '@angular/forms';
import { GeneralService } from 'src/app/home/services/general.service';
import { DataFormService } from 'src/app/reference-data/service/dataForm.service';
import { RequestsService } from 'src/app/home/services/requests.service';

@Component({
  selector: 'app-modal-reject',
  templateUrl: './modal-reject.component.html',
  styleUrls: ['./modal-reject.component.scss'],
})
export class ModalRejectComponent implements OnInit {
  @Output() closeModalReject = new EventEmitter();
  title!: string;
  selectedOption!: string;
  options: DataReject[] = [];
  rejectOption = new FormControl<string | null>(null, Validators.required);
  @Input() idCode!: number;

  constructor(
    public servUser: GeneralService,
    private dataRejectOptionsSrvc: DataFormService,
    private requestSrvc: RequestsService,
  ) {}

  async ngOnInit() {
    this.isCorredor();
    this.options = await this.dataRejectOptionsSrvc.getRejectOptions();
  }

  isCorredor() {
    const isCorredor = this.servUser.getBrokerRol();
    if (isCorredor === false) {
      this.title = 'Rechazar Solitud - Broker';
    } else {
      this.title = 'Rechazar solicitud';
    }
  }

  rejectRequest() {
    if (this.rejectOption.invalid) {
      return this.rejectOption.markAsTouched();
    }
    const editData = {
      id: this.idCode,
      idrequest: this.idCode,
      parameters: {
        updatedAt: '2024-05-02',
        statusRequest: 'Rechazada',
        reasonRejection: 'Se rechaza porque esta feo',
      },
    };
    this.requestSrvc.putRequests(editData);
    this.closeModalReject.emit(false);
  }

  closeModal() {
    this.closeModalReject.emit(false);
  }
}
